import React from "react";

/**
 * WHOLE Neighborhoods mark — a geometric house frame.
 * Solid color only (indigo by default, or white when placed on indigo).
 */
export function LogoMark({ size = 28, tone = "indigo", className = "" }) {
  const stroke = tone === "white" ? "#FBFAFD" : "#1B1F4B";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      aria-hidden="true"
      className={className}
      data-testid="logo-mark"
    >
      {/* outer frame */}
      <path
        d="M4 14 L16 4 L28 14 V27 H4 Z"
        stroke={stroke}
        strokeWidth="2"
        strokeLinejoin="round"
      />
      {/* inner frame */}
      <path
        d="M10 27 V18 H22 V27"
        stroke={stroke}
        strokeWidth="2"
        strokeLinejoin="round"
      />
      {/* center beam */}
      <path d="M16 18 V27" stroke={stroke} strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export function LogoLockup({ tone = "white", size = 28 }) {
  const wordColor = tone === "white" ? "#FBFAFD" : "#1B1F4B";
  return (
    <div className="flex items-center gap-3" data-testid="logo-lockup">
      <LogoMark size={size} tone={tone} />
      <div className="leading-none">
        <div
          style={{
            fontFamily: '"Fraunces", Georgia, serif',
            fontWeight: 600,
            fontSize: 20,
            color: wordColor,
            letterSpacing: "-0.005em",
          }}
        >
          WHOLE
        </div>
        <div
          style={{
            fontFamily: '"Nunito Sans", sans-serif',
            fontWeight: 600,
            fontSize: 10,
            letterSpacing: "0.18em",
            textTransform: "uppercase",
            color: wordColor,
            opacity: 0.72,
            marginTop: 4,
          }}
        >
          Neighborhoods
        </div>
      </div>
    </div>
  );
}
